import type { IFileAttachment } from "@/models/file/"

const BYTES_PER_UNIT = 1024 // Number of bytes in a kilobyte (binary prefix)

export function formatFileSize(bytes?: number): string {
  if (!bytes) return '0 B'
  
  const units = ['B', 'KB', 'MB', 'GB']
  let size = bytes
  let unitIndex = 0

  while (size >= BYTES_PER_UNIT && unitIndex < units.length - 1) {
    size /= BYTES_PER_UNIT
    unitIndex++
  }

  return `${size.toFixed(1)} ${units[unitIndex]}`
}

export function downloadFile(file: IFileAttachment, customFilename?: string): void {
  const a = document.createElement('a')
  a.href = file.url

  // Suggest download filename
  const original = getFilenameFromUrl(file.url)
  const extension = original.split('.').pop()
  const filename = customFilename ? `${customFilename}.${extension}` : original
  a.download = filename

  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

function getFilenameFromUrl(url: string): string {
  // Try to get filename from the last part of the path
  const urlParts = url.split('/')
  const lastPart = urlParts[urlParts.length - 1]
  
  // Remove any query parameters
  const filename = lastPart.split('?')[0]
  
  // If we couldn't get a filename, use a default
  if (!filename) {
    return 'download'
  }
  
  // URL decode the filename to handle any encoded characters
  return decodeURIComponent(filename)
}
